import Model from 'flarum/common/Model';
/**
 * A support ticket. The `can*` booleans are server-computed per-actor gates
 * that the UI uses to decide which moderation controls to show.
 */
export default class SupportTicket extends Model {
  subject = (() => Model.attribute('subject'))();
  status = (() => Model.attribute('status'))();
  decision = (() => Model.attribute('decision'))();
  priority = (() => Model.attribute('priority'))();
  replyCount = (() => Model.attribute('replyCount'))();
  canReply = (() => Model.attribute('canReply'))();
  canUpdate = (() => Model.attribute('canUpdate'))();
  canPostInternalNote = (() => Model.attribute('canPostInternalNote'))();
  canDelete = (() => Model.attribute('canDelete'))();
  canReopen = (() => Model.attribute('canReopen'))();
  canConfirmSolved = (() => Model.attribute('canConfirmSolved'))();
  isDeleted = (() => Model.attribute('isDeleted'))();
  isUnread = (() => Model.attribute('isUnread'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
  updatedAt = (() => Model.attribute('updatedAt', Model.transformDate))();
  lastReplyAt = (() => Model.attribute('lastReplyAt', Model.transformDate))();
  deletedAt = (() => Model.attribute('deletedAt', Model.transformDate))();
  user = (() => Model.hasOne('user'))();
  assignedStaff = (() => Model.hasOne('assignedStaff'))();
  category = (() => Model.hasOne('category'))();
}
flarum.reg.add('linkrobins-support', 'common/models/SupportTicket', SupportTicket);